import * as React from 'react';
import { connect } from 'react-redux';
import { META_REDUCER_NAME } from 'src/react/components/meta/constants';
import { Helmet } from 'react-helmet';
import { reducerRegistry } from '@collaborator/npm_modules/dist/components/redux';
import reducer from 'src/react/components/meta/reducers';
import { TITLE } from 'moduleBase/constants';
reducerRegistry.register(META_REDUCER_NAME, reducer);

var MetaPresenter = function MetaPresenter(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement(Helmet, {
    defer: false
  }, /*#__PURE__*/React.createElement("title", null, title ? "".concat(title, " \u2014 ").concat(TITLE) : TITLE));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    title: state[META_REDUCER_NAME].title
  };
};

export default connect(mapStateToProps)(MetaPresenter);